
interface Props {
    currentStep: number
}

function Stepper({currentStep}: Props) {
    const steps = [
        { name: 'Welcome' },
        { name: 'Choose plan' },
        { name: 'Install' },
        { name: 'Styling' },
        { name: 'Get Started' },
    ];


    return (
        <div className="stepper-wrapper">
            {steps.map((step, index) => (
                <div
                    key={index}
                    className={`stepper-item ${index < currentStep ? 'completed' : ''} ${index === currentStep ? 'active' : ''}`}
                >
                    <div className="step-counter">{index < currentStep ? '✔' : ''}</div>
                    <div className={`step-name ${index < currentStep ? 'nbis-bold' : 'nbis-faded-text'}`}>Step {index + 1}</div>
                    <div className={`step-name ${index < currentStep ? 'nbis-bold' : 'nbis-faded-text'}`}>{step.name}</div>
                </div>
            ))}
        </div>
    );
};

export default Stepper;
